import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { SeoService } from './core/services/seo/seo.service';

/**
 * Route-level SEO resolvers.
 *
 * ResolveFn runs on the server during prerendering (before component init),
 * ensuring meta tags are baked into the static HTML that Google's crawler reads.
 * The component's effect() then keeps them reactive for client-side lang changes.
 */
const homeSeoResolver: ResolveFn<void> = () => {
  inject(SeoService).updateSeo(SeoService.HOME_EN);
};

const privacySeoResolver: ResolveFn<void> = () => {
  inject(SeoService).updateSeo(SeoService.PRIVACY_EN);
};

const termsSeoResolver: ResolveFn<void> = () => {
  inject(SeoService).updateSeo(SeoService.TERMS_EN);
};

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./core/layout/layout').then((m) => m.Layout),
    children: [
      {
        path: '',
        loadComponent: () => import('./modules/home/home').then((m) => m.Home),
        title: 'Echoza | Social Media Management Platform',
        resolve: { seo: homeSeoResolver },
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./modules/terms-conditions/terms-conditions').then((m) => m.TermsConditions),
        title: 'Terms & Conditions | Echoza',
        resolve: { seo: termsSeoResolver },
      },
      {
        path: 'privacy-and-policy',
        loadComponent: () =>
          import('./modules/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
        title: 'Privacy Policy | Echoza',
        resolve: { seo: privacySeoResolver },
      },
      {
        path: '**',
        loadComponent: () =>
          import('./core/layout/components/error-page/error-page').then((m) => m.ErrorPage),
        title: '404 – Page Not Found | Echoza',
      },
    ],
  },
];
